/* eslint-disable @typescript-eslint/no-magic-numbers */
import { CareerId } from '../catalog/career';

export const CAREER_IDS_ALLOWED_FOR_DEALS = [CareerId.Nanny];

export const DEAL_LENGTH_MIN_IN_MS = 60 * 60 * 1000;

export const DEAL_START_MIN_OFFSET_FROM_NOW_IN_MS = 60 * 1000; // one minute;
